import { render, staticRenderFns } from "./Addorganization.vue?vue&type=template&id=4cf7c117&lang=html"
import script from "./Addorganization.vue?vue&type=script&lang=js"
export * from "./Addorganization.vue?vue&type=script&lang=js"
import style0 from "./Addorganization.vue?vue&type=style&index=0&id=4cf7c117&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports